export default __webpack_public_path__ + "media/images/dashboard_icons/gift-fund-43979842f54ae058f9720e8c3473ec40.svg";